import React from "react";
import moment from "moment";
import SearchIcon from "@rsuite/icons/Search";
import MenuIcon from "@rsuite/icons/Menu";

import { Button, DatePicker, Drawer, Modal } from "rsuite";
import { Icon } from "@rsuite/icons";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  allReservaCarro,
  updateReservaCarro,
  resetReserva,
  addReservation,
  canselarReserva as CancelarReservation,
  allReservaCarroCliente,
} from "../../store/modules/reservaCarro/actions";
import { timeout } from "workbox-core/_private";
export default function EntradaSaidaCarros() {
  const { auth } = (state) => state.cliente;
  const dispatch = useDispatch();
  const {
    reservations,
    reserva,
    carrosDisponivel,
    reservaCarrosCliente,
    components,
    behavior,
    form,
    vehicles,
    tipoReserva,
  } = useSelector((state) => state.reserva);

  const setHorario = (key, value) => {
    dispatch(
      updateReservaCarro({
        reservations: { ...reservations, [key]: value },
      })
    );
  };
  const setComponent = (component, state) => {
    dispatch(
      updateReservaCarro({
        components: { ...components, [component]: state },
      })
    );
  };

  function checarDatas() {
    var data_1 = reservations.start_date;
    var data_2 = reservations.end_date;
    if (data_1 > data_2) {
      alert("Data não pode ser maior que a data final");
      dispatch(resetReserva());

      return false;
    } else {
      dispatch(allReservaCarro());
     
    }
  }
  useEffect(() => {
    setHorario("start_date", 
    convertDatePickerTimeToMySQLTime(Date.now()));
    setHorario("end_date", 
    convertDatePickerTimeToMySQLTime(Date.now()));
    dispatch(allReservaCarro());
    dispatch(allReservaCarroCliente());
  }, [])

  const verCarro = (carro) => {
    dispatch(
      updateReservaCarro({
        tipoReserva: "reservar",
      })
    );

    dispatch(
      updateReservaCarro({
        vehicles: { ...carro },
      })
    );

    setComponent("drawer", true);
  };

  const verReservaCarro = (carro) => {
    dispatch(
      updateReservaCarro({
        tipoReserva: "reservado",
      })
    );

    dispatch(
      updateReservaCarro({
        vehicles: { ...carro },
      })
    );

    setComponent("drawer", true);
  };

  const setVehicle = (key, value) => {
    dispatch(
      updateReservaCarro({
        vehicles: { ...vehicles, [key]: value },
      })
    );
  };

  const salvarReserva = () => {
    dispatch(addReservation());
    setComponent("drawer", false);
   
    setHorario("start_date", 
    convertDatePickerTimeToMySQLTime(Date.now()));
    setHorario("end_date", 
    convertDatePickerTimeToMySQLTime(Date.now()));
    dispatch(allReservaCarroCliente());
    setTimeout(() => {
      window.location.reload();
    }, 4000);

  };

  const canselarReserva = () => {
    console.log("estou cancelando")
    dispatch(CancelarReservation());
    setComponent("drawer", false);
    setHorario("start_date", 
    convertDatePickerTimeToMySQLTime(Date.now()));
    setHorario("end_date", 
    convertDatePickerTimeToMySQLTime(Date.now()));
    dispatch(allReservaCarroCliente());
    setTimeout(() => {
      window.location.reload();
    }, 4000);
    
   
  };

  function convertDatePickerTimeToMySQLTime(str) {
    var month, day, year, hours, minutes, seconds;
    var date = new Date(str),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    hours = ("0" + date.getHours()).slice(-2);
    minutes = ("0" + date.getMinutes()).slice(-2);
    seconds = ("0" + date.getSeconds()).slice(-2);

    var mySQLDate = [date.getFullYear(), month, day].join("-");
    var mySQLTime = [hours, minutes, seconds].join(":");
    return [mySQLDate, mySQLTime].join("T");
  }

  function disableDateRanges(range = { startDate: false, endDate: false }) {
    const { startDate, endDate } = range;
    return function disabledDate(current) {
      let startCheck = true;
      let endCheck = true;
      if (startDate) {
        startCheck = current && current < moment(startDate, 'YYYY-MM-DD');
      }
      if (endDate) {
        endCheck = current && current > moment(endDate, 'YYYY-MM-DD');
      }
      return (startDate && startCheck) || (endDate && endCheck);
    };
  }

  return (
    <>
      <Drawer
        open={components.drawer}
        size="full"
        placement="top"
        onClose={() => setComponent("drawer", false)}
      >
        <Drawer.Body>
          <h3>
            {tipoReserva === "reservar" ? "Reservar" : "Reservado"} Horarios{" "}
          </h3>

          <div className="input-group-append d-flex flex-column  col-12 align-content-center">
            <DatePicker
              className=" m-1 col-12"
              disabled={form.disabled}
              disabledDate={(current) => current.isBefore(moment().subtract(1,"day"))}
              ranges={[
                {
                  
                  label: "today",
                  value: new Date(),
                },
              ]}
              format="dd-MM-yyyy HH:mm:ss"
              calendarDefaultDate={new Date()}
              value={
                tipoReserva === "reservar"
                  ? new Date(reservations.start_date)
                  : new Date(vehicles.start_date)
              }
              hideMinutes={(min) => ![0, 30].includes(min)}
              onChange={(e) => {
                setHorario("start_date", convertDatePickerTimeToMySQLTime(e));
              }}
            />

            <DatePicker
              className="m-1 col-12"
              disabled={form.disabled}
              ranges={[
                {
                  label: "today",
                  value: new Date(),
                },
              ]}
              format="dd-MM-yyyy HH:mm:ss"
              calendarDefaultDate={new Date()}
              value={
                tipoReserva === "reservar"
                  ? new Date(reservations.end_date)
                  : new Date(vehicles.end_date)
              }
              hideMinutes={(min) => ![0, 30].includes(min)}
              onChange={(e) => {
                setHorario("end_date", convertDatePickerTimeToMySQLTime(e));
              }}
            />

            <div className="input-group-append">
              <b
                onChange={(e) => {
                  setVehicle("id", e.target.value);
                }}
              >
                {vehicles.id}
              </b>
              <div className="form-group col-12 ">
                <b className="">Model</b>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Modelo do carro"
                  disabled={form.disabled}
                  value={
                    tipoReserva === "reservar"
                      ? vehicles.model
                      : vehicles.vehicle.model
                  }
                  onChange={(e) => {
                    setVehicle("model", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="form-group col-12 ">
              <b className="">Licença</b>
              <input
                type="text"
                className="form-control"
                placeholder="Licença do carro"
                disabled={form.disabled}
                value={
                  tipoReserva === "reservar"
                    ? vehicles.license
                    : vehicles.vehicle.license
                }
                onChange={(e) => {
                  setVehicle("license", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-12 ">
              <b className="">Hodômetro</b>
              <input
                type="text"
                className="form-control"
                placeholder="hodômetro do carro"
                disabled={form.disabled}
                value={
                  tipoReserva === "reservar"
                    ? vehicles.odometer
                    : vehicles.vehicle.odometer
                }
                onChange={(e) => {
                  setVehicle("odometer", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-12 ">
              <b className="">Consumo</b>
              <input
                type="text"
                className="form-control"
                placeholder="hodômetro do carro"
                disabled={form.disabled}
                value={
                  tipoReserva === "reservar"
                    ? vehicles.consumption
                      ? vehicles.consumption
                      : ""
                    : vehicles.vehicle.consumption
                    ? vehicles.vehicle.consumption
                    : ""
                }
                onChange={(e) => {
                  setVehicle("consumption", e.target.value);
                }}
              />
            </div>
            <div className="form-group col-12 ">
              <b className="">Disponivel</b>
              <input
                type="text"
                className="form-control"
                placeholder="active? true / false"
                disabled={form.disabled}
                value={
                  tipoReserva === "reservar"
                    ? vehicles.active
                      ? "Sim"
                      : "Não"
                      ? vehicles.active
                        ? "Sim"
                        : "Não"
                      : ""
                    : vehicles.vehicle.active
                    ? "Sim"
                    : "Não"
                }
                onChange={(e) => {
                  setVehicle("active", e.target.value);
                }}
              />
            </div>
           

            {tipoReserva === "reservar" && (
              <div className="input-group mt-1  col-12 align-content-center">
                <div className="input-group-prepend col-12 ">
                  <span className="input-group-text  col-12 align-content-center bg-dark  text-white ">
                    Comentario do cliente
                  </span>
                </div>
                <textarea
                  className="form-control"
                  aria-label="With textarea"
                  onChange={(e) => {
                    dispatch(
                      updateReservaCarro({
                        reservations: {
                          ...reservations,
                          user_observations: e.target.value,
                        },
                      })
                    );
                  }}
                ></textarea>
              </div>
            )}
          </div>
          <Button
            block
            appearance="primary"
            className=" mt-3"
            color={tipoReserva === "reservar" ? "green" : "red"}
            size="lg"
            loading={form.saving}
            onClick={() =>
              tipoReserva === "reservar" ? salvarReserva() :  canselarReserva()
            }
          >
            {tipoReserva === "reservar" ? "Reservar" : "Cancelar"} um
            agendamento
          </Button>
          <Button
            block
            appearance="primary"
            className=" mt-3"
            color="yellow"
            size="lg"
            loading={form.saving}
            onClick={() => {
              setComponent("drawer", false);
            }}
          >
            Voltar
          </Button>
          {behavior === "update" && (
            <Button
              appearance="primary"
              loading={form.saving}
              color="red"
              size="lg"
              block
              className="mt-1"
              onClick={() => {
                setComponent("confirmDelete", true);
              }}
            >
              {" "}
              Remover Horario
            </Button>
          )}
        </Drawer.Body>
      </Drawer>
      <Modal
        open={components.confirmDelete}
        onHide={() => setComponent("confirmDelete", false)}
        size="xs"
      >
        <Modal.Body>
          <Icon
            icon="remind"
            style={{
              color: "#ffb300",
              fontSize: 24,
            }}
          />
          {"   "}Tem certeza que deseja excluir? Essa ação será inrreversivel!
        </Modal.Body>
        <Modal.Footer>
          <Button
            loading={form.saving}
            onClick={() => {}}
            appearance="primary"
            color="red"
          >
            Sim, tenho certeza!
          </Button>
          <Button
            loading={form.saving}
            onClick={() => setComponent("confirmDelete", false)}
            appearance="primary"
            color="green"
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
      <div className=" d-fex flex-column mt-1  col-11 p-1 col-sd-12 col-xl-8 ">
        <div className="d-flex align-items-center flex-row justify-content-between">
          <div className="d-flex flex-column   col-10 m-0">
            <DatePicker
              className="p-0 m-1"
              ranges={[
                {
                  label: "today",
                  value: new Date(),
                },
              ]}
              format="dd-MM-yyyy HH:mm:ss"
              calendarDefaultDate={new Date()}
              color="orange"
              style={{ width: "auto" }}
              hideMinutes={(min) => ![0, 30].includes(min)}
              onChange={(e) => {
                setHorario("start_date", convertDatePickerTimeToMySQLTime(e));
              }}
            />

            <DatePicker
              className="p-0 m-1 mt-0"
              ranges={[
                {
                  label: "today",
                  value: new Date(),
                },
              ]}
              format="dd-MM-yyyy HH:mm:ss"
              calendarDefaultDate={new Date()}
              style={{ width: "auto" }}
              hideMinutes={(min) => ![0, 30].includes(min)}
              onChange={(e) => {
                setHorario("end_date", convertDatePickerTimeToMySQLTime(e));
              }}
            />
          </div>

          <div>
            <button
              className="btn btn-warning p-3 m-1 btn-lg "
              onClick={() => {
                checarDatas();
              }}
            >
              {" "}
              <SearchIcon />
            </button>
          </div>
        </div>

        <div className=" d-flex flex-column text-white  mt-1  bg-dark  block   text-center col-12 ">
          <div>
            <b className="  text-center">Lista de carros</b>
          </div>
          <div className="d-flex p-1 col-11 flex-column">
            {carrosDisponivel.length > 0 ? (
              carrosDisponivel.map((carro, index) => {
                return (
                  <div className=" d-flex   align-items-center bg-dark m-1  text-center justify-content-between">
                    <div className="  d-flex flex-row text-center   ">
                      <div className=" d-flex  flex-row  ">
                        <div className="d-flex flex-column col-5">
                          <img
                            key={`${index}+${carro.photo}`}
                            src={`data:image/png;base64,${carro.photo}`}
                            className=" img-thumbnail m-1"
                            alt="Imagem responsiva"
                          />
                        </div>
                        <div className="d-flex flex-row m-1  ">
                          <h3>
                             <b
                            className=" text-white bg-dark  text-center"
                            key={`${index}+${carro.brand}`}
                          >
                            {carro.brand.name}
                          </b>
                            </h3>
                          <b
                            className=" text-white bg-dark m-1 text-center"
                            key={`${index}+${carro.model}`}
                          >
                            {carro.model}
                          </b>
                          
                        </div>
                      </div>
                    </div>
                    <div className=" d-flex flex-row justify-content-end align-items-end  ">
                      <button
                        className="btn btn-success  rounded-0  "
                        onClick={() => {
                          verCarro(carro);
                        }}
                      >
                        {" "}
                        <MenuIcon />
                      </button>
                    </div>
                  </div>
                );
              })
            ) : (
              <h3>Escolha data de inicio e final</h3>
            )}
          </div>
        </div>
      </div>
      
      <div className=" text-white    bg-dark mt-1 text-center col-12 ">
        <div className="mt-2">
          <b className="  text-center  ">Carros reservados</b>
        </div>
        <div className="col col-11  col-sd-6 ">
          {reservaCarrosCliente.length > 0 ? (
            reservaCarrosCliente.map((reserva, index) => {
              return (
                <div className=" text-white  rounded block  bg-warning m-1 text-center">
                  <div className=" d-flex text-white  rounded block  bg-warning m-1 text-center">
                    <b className=" text-white   block  bg-warning mt-1 text-center m-1">
                      {reserva.vehicle.brand.name}
                    </b>
                    <b className=" text-white   block  bg-warning mt-1 text-center m-1">
                      {reserva.vehicle.model}
                    </b>
                    <b className=" text-white   block  bg-warning mt-1 text-center m-1">
                      Email: {reserva.back_user.email}
                    </b>
                  </div>
                  <div className=" d-flex   text-white  rounded block  bg-warning m-1 text-center">
                    <b> Reserva: </b>
                    <div>
                      <input
                        disabled="true"
                        type="text"
                        className="form-control"
                        placeholder="active? true / false"
                        value={reserva.start_date}
                      />
                      <input
                        disabled="true"
                        type="text"
                        className="form-control"
                        placeholder="active? true / false"
                        value={reserva.end_date}
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-row text-center justify-content-center   align-content-center">
                    <Button
                      appearance="primary"
                      color="green"
                      size="xs"
                      className="btn btn-success mx-3 col-6    col-xl-3 m-3 "
                      onClick={() => {
                        verReservaCarro(reserva);
                      }}
                    >
                      {" "}
                      Ver
                    </Button>
                  </div>
                </div>
              );
            })
          ) : (
            <h3>Não tem carros reservados</h3>
          )}
        </div>
      </div>
    </>
  );
}
